import { Text } from "@/elements"
import { CheckVerified } from "@/icons/outline"
import { SlashCircleIcon } from "@/icons/outline/SlashCircleIcon"
import { TextVariant } from "@/theme"
import clsx from "clsx"
import pluralize from "pluralize"

interface Props {
  background?: boolean
  textVariant?: TextVariant
  positionName?: string
  creditsCount?: number
}

export const CreditsTag: React.FC<Props> = ({
  background = false,
  textVariant = "label",
  positionName,
  creditsCount,
}) => {
  return (
    <div
      className={clsx(
        "flex flex-row items-center gap-x-1 py-1",
        background && "rounded-sm bg-bg-2 px-[6px]",
        background && creditsCount === 0 ? "bg-red-light" : background ? "bg-green-light" : ""
      )}>
      {creditsCount === 0 ? (
        <SlashCircleIcon className="shrink-0 stroke-red-default" width={18} height={18} />
      ) : (
        <CheckVerified className={"shrink-0 stroke-green-dark"} width={18} height={18} />
      )}
      <Text variant={textVariant} className={clsx(creditsCount === 0 ? "text-red-default" : "text-green-dark")}>
        {creditsCount} {positionName} {pluralize("credit", creditsCount)}
      </Text>
    </div>
  )
}
